/**
 * Red List Index chart — tuneable draw-in motion.
 *
 * Line + CI band animate left→right on scroll-into-view and again on
 * flyway filter change (`drawKey`). Reduced-motion skips to the final
 * state. Ease comes from `@/motion/tokens` (`easeStandard`).
 */

export const redListIndexMotion = {
  /** Draw duration for the index line + CI clip wipe (seconds). */
  drawSeconds: 1,
  /** IntersectionObserver root margin for the scroll-into-view trigger. */
  inViewMargin: '0px',
  /**
   * Start the draw when this fraction of the chart is visible (halfway
   * down the graph).
   */
  inViewThreshold: 0.5,
  /**
   * Play draw once per mount. Filter changes remount the animated nodes
   * via `drawKey`, so they still replay without resetting `inView`.
   */
  inViewOnce: true,
  /**
   * Seconds between flanking Graph Stat pod spring-badge reveals (improved
   * then deteriorated) — matches chord callout disc stagger.
   */
  sideStatStaggerSeconds: 0.2,
} as const;

export type RedListIndexMotionConfig = typeof redListIndexMotion;
